import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetLaboratoryPlanRequest, GetLaboratoryPlanResponse, GetWaterMeasurementRequest, GetWaterMeasurementResponse, GetWellCategoryRequest, GetWellCategoryResponse, PostLaboratoryPlanRequest, PostLaboratoryPlanResponse, PostWaterMeasurementRequest, PostWaterMeasurementResponse, PostWellCategoryRequest, PostWellCategoryResponse } from './types/TMiniportServices';

const URL_Prefix = '/minireport';

export const minireportService = createApi({
    reducerPath: 'minireportService',
    baseQuery: getBaseQuery,
    tagTypes: ['Report'],
    endpoints: (builder) => ({
        getWellCategory: builder.query<GetWellCategoryResponse, GetWellCategoryRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/well_category/${params.project_uuid}/`,
                method: 'GET',
                // params: params,
            }),
        }),
        postWellCategory: builder.mutation<PostWellCategoryResponse, PostWellCategoryRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/export/well_category/${body.project_uuid}/`,
                method: 'POST',
                body: body,
                responseHandler: (response) => response.blob(),
            }),
            invalidatesTags: ['Report'],
        }),
         getWaterMeasurement: builder.query<GetWaterMeasurementResponse, GetWaterMeasurementRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/water_measurement/${params.project_uuid}/`,
                method: 'GET',
            }),
            providesTags: ['Report'],
        }),
        postWaterMeasurement: builder.mutation<PostWaterMeasurementResponse, PostWaterMeasurementRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/export/water_measurement/${body.project_uuid}/`,
                method: 'POST',
                body: body,
                responseHandler: (response) => response.blob(),
            }),
            invalidatesTags: ['Report'],
        }),
         getLaboratoryPlan: builder.query<GetLaboratoryPlanResponse, GetLaboratoryPlanRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/laboratory_plan/${params.project_uuid}/`,
                method: 'GET',
            }),
            providesTags: ['Report'],
        }),
        postLaboratoryPlan: builder.mutation<PostLaboratoryPlanResponse, PostLaboratoryPlanRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/export/laboratory_plan/${body.project_uuid}/`,
                method: 'POST',
                body: body,
                responseHandler: (response) => response.blob(),
            }),
            invalidatesTags: ['Report'],
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetWellCategoryQuery,
    useLazyGetWellCategoryQuery,
    usePostWellCategoryMutation,
    useGetWaterMeasurementQuery,
    useLazyGetWaterMeasurementQuery,
    usePostWaterMeasurementMutation,
    useGetLaboratoryPlanQuery,
    useLazyGetLaboratoryPlanQuery,
    usePostLaboratoryPlanMutation,
} = minireportService;